export default __webpack_public_path__ + "7b6c1baee07ab0d341a9f4084e6786ca.png";